import { t } from '@lingui/core/macro';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { StringArrayFilter } from './StringArrayFilter';
import { useGetTeams } from './useGetTeams/useGetTeams';
export const allowedTeamsFilterLabel = () => t({ message: 'Team access', comment: 'Insights filter: Teams with access' });
/**
 * Filtering teams with access to FilSystemEntries.
 */
export const AllowedTeamsFilter = withFilterErrorBoundary(() => {
    const { data, error, loading } = useGetTeams();
    const disabled = Boolean(loading || error);
    return <StringArrayFilter name="allowedTeams" items={data} label={allowedTeamsFilterLabel()} loading={disabled}/>;
});
